/**
 * Avada Order Limits -> Dawn quantity input floor.
 *
 * The Avada Order Limits app sets the initial quantity on a product page but
 * leaves min="1" / data-min="1" on Dawn's quantity inputs, so the "-" button
 * happily walks the customer below the real minimum. This reads the per-variant
 * minimum from the app's own rules and writes it into min/data-min on every
 * quantity input (product page and each cart line), so Dawn disables "-" and the
 * browser rejects smaller values.
 *
 * Single source of truth: the numbers live in the Avada app, never here. If the
 * app is absent or changes its internal API, this does nothing and Dawn's stock
 * behaviour applies.
 */
(function () {
  var SELECTOR = 'input.quantity__input';

  function parseCondition(rule) {
    var condition = rule && rule.condition;
    if (typeof condition === 'string') {
      try {
        condition = JSON.parse(condition);
      } catch (error) {
        return null;
      }
    }
    return condition || null;
  }

  // Highest product_quantity minimum among the rules Avada says apply here.
  function minForVariant(variantId) {
    var helper = window.AVADA_ORDER_LIMIT_HELPER;
    if (!helper || typeof helper.getRulesByVariantId !== 'function' || !variantId) return null;

    var rules;
    try {
      rules = helper.getRulesByVariantId(Number(variantId));
    } catch (error) {
      return null;
    }
    if (!Array.isArray(rules) || !rules.length) return null;

    var min = null;
    for (var i = 0; i < rules.length; i++) {
      var condition = parseCondition(rules[i]);
      if (!condition || condition.type !== 'product_quantity') continue;
      if (typeof condition.min !== 'number' || condition.min <= 0) continue;
      if (min === null || condition.min > min) min = condition.min;
    }
    return min;
  }

  function variantIdFor(input) {
    if (input.dataset.quantityVariantId) return input.dataset.quantityVariantId;

    var form = input.form || input.closest('form');
    var hidden = form && form.querySelector('input[name="id"]');
    if (hidden && hidden.value) return hidden.value;

    var avada = window.AVADA_ORDER_LIMIT;
    if (avada && avada.selectedVariant && avada.selectedVariant.id) return avada.selectedVariant.id;

    return null;
  }

  function apply() {
    var inputs = document.querySelectorAll(SELECTOR);

    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var min = minForVariant(variantIdFor(input));
      if (min === null || min <= 1) continue;

      var value = String(min);
      if (input.getAttribute('min') === value && input.dataset.min === value) continue;

      input.setAttribute('min', value);
      input.dataset.min = value;

      // Let Dawn re-evaluate whether "-" should be disabled.
      var wrapper = input.closest('quantity-input');
      if (wrapper && typeof wrapper.validateQtyRules === 'function') wrapper.validateQtyRules();
    }
  }

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = window.setTimeout(function () {
      pending = null;
      apply();
    }, 120);
  }

  function start() {
    apply();

    // The app bundle loads asynchronously; keep retrying for the first ~10s.
    var tries = 0;
    var poll = window.setInterval(function () {
      apply();
      if (++tries >= 25) window.clearInterval(poll);
    }, 400);

    // Dawn swaps cart sections out via AJAX, which drops our attributes.
    // childList only - apply() touches attributes, so this cannot self-trigger.
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }

    document.addEventListener('change', schedule, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
